<form #editForm="ngForm" (ngSubmit)="onSubmit(editForm)">
  <div id="my-profile">
    <div class="center" fxLayout="column">
      <div class="top-bg"></div>
      <div
        class="header"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayout.xs="column"
        fxLayoutAlign.xs="space-between center"
      >
        <div fxLayout="row">
          <mat-icon class="logo-icon" style="cursor: pointer">
            account_box
          </mat-icon>
          <span class="header-title">
            {{ userInfo?.lastName + ", " | uppercase }}{{ userInfo?.firstName }}
            {{ userInfo?.middleName }}
          </span>
        </div>
        <div class="example-button-row text-white">
          <button routerLink=".." type="button" mat-stroked-button>
            <mat-icon class="add-button-icon">close</mat-icon>CANCEL
          </button>
          <button
            [disabled]="emailOrMobileNotFilled || editForm.invalid"
            type="submit"
            mat-raised-button
            color="primary"
          >
            <mat-icon class="add-button-icon">save</mat-icon>SAVE
          </button>
        </div>
      </div>
      <div
        class="content"
        fxLayout="column"
        fxLayoutAlign="start start"
        fxLayout.gt-md="column"
        fxLayout.xs="column"
        fxLayout.sm="column"
      >
        <div
          fxLayout.xs="column"
          fxLayout.sm="column"
          fxLayout.md="row"
          class="content-bg"
          fxLayout="row"
          fxLayoutAlign="space-between stretch"
        >
          <div class="content-card mat-elevation-z4" fxLayout="column">
            <div
              fxLayout="row"
              fxLayout.xs="column"
              fxLayoutAlign.xs="start"
              class="create-view"
            >
              <span class="body2">Profile details</span>
            </div>

            <div class="mt-20" fxLayout="column" fxLayoutGap="2%">
              <div fxLayout>
                <mat-form-field appearance="fill">
                  <mat-label>User ID</mat-label>
                  <input
                    type="text"
                    matInput
                    name="userId"
                    ngModel
                    pattern="^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$"
                    required
                    minlength="3"
                    maxlength="10"
                  />
                  <mat-error *ngIf="editForm.hasError('required', ['userId'])">
                    User id is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="editForm.hasError('pattern', ['userId'])"
                    >Enter at least 3 alphanumeric value</mat-error
                  >
                </mat-form-field>
              </div>
              <div fxLayout fxLayoutGap="3%">
                <mat-form-field fxFlex="25%" appearance="fill">
                  <mat-label>Last name</mat-label>
                  <input
                    type="text"
                    maxlength="50"
                    matInput
                    name="lastName"
                    ngModel
                    pattern="^[a-zA-Z]+$"
                    required
                  />
                  <mat-error *ngIf="editForm.hasError('pattern', ['lastName'])"
                    >Only alphabets are allowed</mat-error
                  >
                  <mat-error
                    *ngIf="editForm.hasError('required', ['lastName'])"
                  >
                    Last name is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>First name</mat-label>
                  <input
                    type="text"
                    maxlength="50"
                    matInput
                    name="firstName"
                    pattern="^[a-zA-Z]+$"
                    ngModel
                    required
                  />
                  <mat-error *ngIf="editForm.hasError('pattern', ['firstName'])"
                    >Only alphabets are allowed</mat-error
                  >
                  <mat-error
                    *ngIf="editForm.hasError('required', ['firstName'])"
                  >
                    First name is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Middle name</mat-label>
                  <input
                    type="text"
                    maxlength="50"
                    matInput
                    name="middleName"
                    pattern="^[a-zA-Z]+$"
                    ngModel
                  />
                  <mat-error
                    *ngIf="editForm.hasError('pattern', ['middleName'])"
                    >Only alphabets are allowed</mat-error
                  >
                  <mat-error
                    *ngIf="editForm.hasError('required', ['middleName'])"
                  >
                    Middle name is <strong>required</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxLayout fxLayoutGap="3%">
                <mat-form-field fxFlex="25%" appearance="fill">
                  <mat-label>Email</mat-label>
                  <input
                    #emailRef
                    maxlength="50"
                    matInput
                    name="emailId"
                    type="email"
                    required
                    pattern="([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+"
                    ngModel
                  />
                  <mat-error *ngIf="editForm.hasError('pattern', ['emailId'])"
                    >Please enter a valid email address</mat-error>
                  <mat-error *ngIf="editForm.hasError('required', ['emailId'])"
                    >Email address is <strong>required</strong></mat-error>
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Country Code</mat-label>
                  <span matPrefix>+ &nbsp;</span>
                  <input
                    type="number"
                    matInput
                    name="countryCode"
                    ngModel
                    [readonly]="userInfo?.userTypeId !== 1"
                    (keydown)="preventDash($event)"
                    (paste)="false"
                  />
                </mat-form-field>
                <mat-form-field class="example-full-width" appearance="fill">
                  <mat-label>Mobile</mat-label>
                  <input
                    #phoneRef
                    type="text"
                    pattern="^-?(0|[1-9]\d*)?$"
                    minlength="5"
                    maxlength="15"
                    matInput
                    name="contactNumber"
                    ngModel
                  />
                  <mat-error
                    *ngIf="
                      editForm.hasError('pattern', ['contactNumber']) ||
                      editForm.hasError('minlength', ['contactNumber'])
                    "
                    >Please enter a valid mobile number</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
